import { useCallback } from 'react'

import { SecondaryCategoryRowStyled } from './styles/SecondaryCategoryRowStyled'

export interface ISecondaryCategoryRowProps {
  secondaryCategoryId: number
  name: string
  isActive: boolean
  onSelect: (secondaryCategoryId: number) => void
}

export const SecondaryCategoryRow = ({
  secondaryCategoryId,
  name,
  isActive,
  onSelect,
}: ISecondaryCategoryRowProps) => {
  const handleClick = useCallback(
    () => onSelect(secondaryCategoryId),
    [onSelect, secondaryCategoryId]
  )

  return (
    <SecondaryCategoryRowStyled
      type='button'
      aria-pressed={isActive}
      $isActive={isActive}
      onClick={handleClick}
    >
      {name}
    </SecondaryCategoryRowStyled>
  )
}

SecondaryCategoryRow.displayName = 'SecondaryCategoryRow'
